/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import RefundPolicy from "../components/page-sections/refund/RefundPolicy";

/* Session Imports */
import { withIronSessionSsr } from "iron-session/next";
import { sessionOptions } from "../lib/session";

const TermsOfUse = ({ user }) => {
  return (
    <React.Fragment>
      <Layout
        title="Refund & Cancellation Policy | Sentient Developers "
        description="Review Sentient Developers' refund and cancellation policy for clarity on booking refunds, timelines, and customer rights. Simple, secure, and transparent process."
        user={user}
      >
        <RefundPolicy />
      </Layout>
    </React.Fragment>
  );
};

export default TermsOfUse;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
